import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-16 sm:py-24 bg-white" data-id="element-185">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-187">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-8" data-id="element-188">
            Lo que pasa en la mayoría de los consultorios
          </h2>

          <div className="prose prose-lg max-w-none text-gray-700 space-y-4" data-id="element-189">
            <p className="text-xl font-medium text-teal-700" data-id="element-190">
              Son las 7 de la tarde. Terminaste tu última sesión. Estás agotada.
            </p>

            <p data-id="element-191">
              Pero antes de poder descansar todavía te quedan 40 minutos de
              tarea: buscar qué actividad llevarle mañana al paciente con
              deterioro leve, adaptar algo de internet que no está pensado para
              adultos mayores, imprimir, cortar, ordenar.
            </p>

            <p data-id="element-192">Y todo eso después de un día entero de trabajo clínico.</p>

            <p data-id="element-193">
              Otros abren Pinterest y encuentran actividades de jardín de
              infantes disfrazadas de estimulación cognitiva. Otros usan siempre
              las mismas fichas y sienten que el tratamiento no avanza. Otros
              improvisan en el momento y salen de la sesión con la sensación de
              que podrían haber hecho más.
            </p>

            <p data-id="element-194">
              Y casi todos terminan trabajando fuera de hora. No por falta de
              compromiso sino porque nunca tuvieron un sistema clínico completo
              que les diera todo resuelto.
            </p>

            <p className="text-xl font-bold text-gray-900" data-id="element-195">
              Mientras tanto el paciente llega mañana a las 9. Y el reloj sigue
              corriendo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}